import api from '../../services/serviceBase'
import {queryOldDashboard} from '../../util/OldDashboardLink.js'

export default {
   
    async getInbox(InboxMessage){
        return api.execute('post', `/Messaging/GetInbox`,InboxMessage)
    },
    sendMessageToListOfUsers(sendEmailMessage) {
        return api.execute('post', `/Messaging/ActionSendMessage`,sendEmailMessage)
    },
    deleteMessages(login, listofMessageIds){
        return api.execute('post', `/Messaging/DeleteMessages?login=${login}&messageIds=${listofMessageIds}`)
    },
    markMessagesAsRead(login, listofMessageIds){
        return api.execute('post', `/Messaging/MessageMarkRead?login=${login}&messageIds=${listofMessageIds}`)
    },
    unmarkMessagesAsRead(login, listofMessageIds){
        return api.execute('post', `/Messaging/MessageMarkUnRead?login=${login}&messageIds=${listofMessageIds}`)
    }
}